import { c as _c } from "react/compiler-runtime";
import styled from 'styled-components';
import { Link as NextLink } from '@/i18n/routing';
import Typography from '@/components/core/Typography';
import { ReactNode } from 'react';
export const LinkTypography = styled(Typography)`
    color: ${({
  theme
}) => theme.colors.palette.blue_500};
    cursor: pointer;
`;
const StyledLink = styled(NextLink)`
    text-decoration: none;
`;
export function Link(t0) {
  const $ = _c(18);
  let children;
  let href;
  let modifier;
  let rest;
  let size;
  let target;
  let variant;
  if ($[0] !== t0) {
    ({
      children,
      href,
      target,
      size,
      variant,
      modifier,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = href;
    $[3] = modifier;
    $[4] = rest;
    $[5] = size;
    $[6] = target;
    $[7] = variant;
  } else {
    children = $[1];
    href = $[2];
    modifier = $[3];
    rest = $[4];
    size = $[5];
    target = $[6];
    variant = $[7];
  }
  const t1 = target ?? "_self";
  let t2;
  if ($[8] !== children || $[9] !== modifier || $[10] !== size || $[11] !== variant) {
    t2 = <LinkTypography variant={variant} modifier={modifier} size={size}>{children}</LinkTypography>;
    $[8] = children;
    $[9] = modifier;
    $[10] = size;
    $[11] = variant;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== href || $[14] !== rest || $[15] !== t1 || $[16] !== t2) {
    t3 = <StyledLink href={href} target={t1} {...rest}>{t2}</StyledLink>;
    $[13] = href;
    $[14] = rest;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
}